import Atc from '../../../../Lib/ATC';

import homeGetLocation from './getLocation';
import homeGetFeaturedProducts from './getFeaturedProducts';
import homeGetGoldPrice from './getGoldPrice';
import homeGetHello from './getHello';
import homeGetProductWidgets from './getWidgets';

export const ErrorTypes = Atc.UseCases.Types.JemisysErrorTypes.LocationErrorTypes;

export default {
    homeGetLocation,
    homeGetFeaturedProducts,
    homeGetGoldPrice,
    homeGetHello,
    homeGetProductWidgets,
};
